var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21893 5.78107C7.17753 4.73965 5.48911 4.73965 4.44771 5.78107L1.78104 8.44773C0.739652 9.48913 0.739652 11.1775 1.78104 12.2189C2.82244 13.2603 4.51088 13.2603 5.55228 12.2189L6.28666 11.4846M5.78107 8.21893C6.82246 9.26033 8.51086 9.26033 9.55226 8.21893L12.2189 5.55229C13.2603 4.51089 13.2603 2.82245 12.2189 1.78105C11.1775 0.739652 9.48913 0.739652 8.44773 1.78105L7.71466 2.51412",
    stroke: "#EDF0F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3b6f09f479d592898b4469182996fac1.svg";
export { ForwardRef as ReactComponent };